import React from "react";
import aboutus from '../../Assets/aboutus.jpg'
import bgimage from '../../Assets/bgimage.PNG'


const AboutPage = () => {

    const backgroundStyle = {
        backgroundImage: `url(${bgimage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        height: '40vh'
    };
    return (
        <div className="min-h-screen">
            <div style={backgroundStyle}>
                <h1 className='bheading text-5xl pt-40 md:text-6xl lg:text-6xl font-semibold text-center text-white'>About Us</h1>
            </div>

            <section className="container mx-auto py-16 px-4">
                <div className="grid md:grid-cols-2 gap-8 items-center">
                    <div>
                        <h2 className="text-3xl font-bold text-gray-800 mb-6">
                            Welcome to KayDeeTech
                        </h2>
                        <p className="mb-4">
                            Welcome to KayDeeTech, where we
                            redefine digital marketing and online business activities through
                            practical experience. As the pioneers of this integrated approach,
                            we stand apart as a company that believes in gaining firsthand
                            insights before extending our services to other businesses and
                            individuals.
                        </p>
                        <h3 className="text-2xl font-semibold text-gray-800 mb-4">
                            About KayDeeTech
                        </h3>
                        <p className="mb-4">
                            Integrated Digital Ventures Solutions or KayDeeTech is more than just a
                            company — it's a vision that encapsulates a transformative business
                            model. Our journey starts with a commitment to understanding the
                            digital landscape through direct engagement. We believe that real
                            value comes from experiencing the very strategies and solutions we
                            offer to our clients.
                        </p>
                    </div>
                    <div>
                        <img
                            className="lg:-mt-60 md:-mt-60 rounded-lg shadow-lg"
                            src={aboutus}
                            alt="About KayDeeTech"
                        />
                    </div>
                </div>
                <div className="mt-12 grid md:grid-cols-2 gap-8 items-center">
                    <div>
                        <h3 className="text-2xl font-semibold text-gray-800 mb-4">
                            Our Approach
                        </h3>
                        <p className="mb-4">
                            At KayDeeTech, we shatter the traditional mold of theoretical
                            consultancy. We're not satisfied with merely offering generic
                            advice — our mission is to provide comprehensive insights,
                            strategies, and solutions deeply rooted in practical experience.
                        </p>
                    </div>
                    <div>
                        <h3 className="text-2xl font-semibold text-gray-800 mb-4">
                            Why We're Different
                        </h3>
                        <p className="mb-4">
                            In our realm, digital ventures and activities converge under a
                            single umbrella, creating a dynamic synergy of knowledge. Our
                            approach stems from the belief that success is a result of both
                            accomplishments and challenges.
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AboutPage;
